import { FC } from 'react';
import { PenToSquareIcon } from '../../theme/Icons';
import { ViewNoteSection } from './ViewNoteSection';

export const UserNotes: FC<{ content: string; editHandler: () => void; }> = ({ content, editHandler }) => {
    return (
        <div style={{marginTop: 8}}>
            <ViewNoteSection title="Your Notes" Icon={PenToSquareIcon}>
                {content ? (
                    <div>{content}</div>
                ): (
                    <div>
                        <div style={{display: 'inline-block', cursor: 'pointer', color: 'var(--ion-color-primary)'}} onClick={editHandler}>Edit</div> to add your own notes.
                    </div>
                )}
            </ViewNoteSection>
        </div>
    );
};
